<template>
  <div v-if="column.type === 'label'"
    :style="column.style">
    <span v-if="column.vtype === 'money'">
      {{ column.label | money((column.vtypeDefault || ''), (column.vdp || 2)) }}
      <!-- <div style="background-color:blue;">
        {{ column.label }}
      </div> -->
    </span>
    <span v-else-if="column.vtype === 'percent'">
      {{ column.label | percent }}
    </span>
    <span v-else-if="column.isHtml" v-html="column.label"></span>
    <span v-else>
      {{ column.label }}
    </span>
  </div>
</template>

<script>
// import _ from 'lodash'

export default {
  name: 'form-label',
  components: {
  },
  props: ['column'],
  data () {
    return {
    }
  },
  computed: {
    modules: function () {
      return this.$store.getters.user.modules
    },
  },
  watch: {
  },
  created () {
  },
  mounted () {
    this.refresh()
  },
  methods: {
    async refresh () {
    }
  }
}
</script>

<style lang="scss">
@import "../styles/base.scss";

.form-label {
}

</style>
